// extracted by mini-css-extract-plugin
module.exports =  {"totalPremiumContainer":"PolicyVehiclesDriversInfo_totalPremiumContainer__dCvIc","policyDriverContainer":"PolicyVehiclesDriversInfo_policyDriverContainer__CzxHA"};